export const RESET_STUDIO_ACTION = 'RESET_STUDIO';
export const LOGOUT_ACTION = 'LOGOUT_ACTION';
